module.exports = __webpack_public_path__ + "img/004_telepathy.4caf2550.gif";